import { Box } from '@material-ui/core';
import { getLoanById } from '@nemuru-eng/js-api-client';
import { useParams } from 'react-router-dom';

import {
  LENDER_ERROR_HASH_ID,
  LoanApplication,
} from '@/components/shared/components/ConditionsSummary/LoanConditionsSummary/components/LenderApplications/components/LoanApplication/LoanApplication';
import { MerchantChannelAgentLoanApplications } from '@/components/shared/components/ConditionsSummary/LoanConditionsSummary/components/LenderApplications/components/MerchantChannelAgentLoanApplications';
import { LoanApplicationMode } from '@/components/shared/components/ConditionsSummary/LoanConditionsSummary/components/LenderApplications/types/LoanApplicationMode';
import { IconHeader } from '@/components/shared/components/IconHeader';
import { PendingDataWarning } from '@/components/shared/components/PendingDataWarning';
import { useCache } from '@/hooks/requests/useCache';
import { useUser } from '@/hooks/useUser';

interface LoanApplicationsProps {
  enableApplicationProcessing: boolean;
  mode: LoanApplicationMode;
}

export const LoanApplications = ({ enableApplicationProcessing, mode }: LoanApplicationsProps) => {
  const { loanId } = useParams();
  const { userEntity } = useUser();

  if (!loanId) return null;

  const { data: loan } = useCache(getLoanById, { loanId });

  return (
    <Box display={'flex'} flexDirection={'column'} id={LENDER_ERROR_HASH_ID}>
      <IconHeader iconName={'account_balance'} labelTid={'LENDER_APPLICATIONS'} color={'secondary'} />
      <Box mb={3} />
      {loan?.loanApplicationIds?.length && loanId ? (
        userEntity?.isRoleMerchantChannelOrAgent() ? (
          <MerchantChannelAgentLoanApplications loan={loan} mode={mode} />
        ) : (
          Object.values(loan.loanApplicationIds).map((applicationId, key) => (
            <Box id={`application-${key}`} key={`application-${key}`}>
              <LoanApplication
                loan={loan}
                loanApplicationId={applicationId.value}
                processingEnabled={enableApplicationProcessing}
                mode={mode}
              />
            </Box>
          ))
        )
      ) : (
        <PendingDataWarning />
      )}
    </Box>
  );
};
